import Layout from "../../../components/Layout";
import FormPostFunc from "../Formularios/formPostUser";

export default function PostAluno() {
  return Layout(FormPostFunc, "Alunos");
}
